import React from "react";
import HeroSection3 from '../sectionBlocks/HeroSection3';
import NFTMarketPlace from '../sectionBlocks/NFTMarket';
import Footer from '../sectionBlocks/Footer';

const Bedrooms = ({loading, data, error, localData}) => {
  return (
    <>
      <HeroSection3 categoryName={"Bedrooms"}/>
      <NFTMarketPlace 
        displayCollectionName = {`dn`} 
        collectionName = {``} 
        displayPagination = {``} 
        displayLink = {`dn`} 
        linkAddress = {``} 
        linkTitle = {``} 
        fetchingCardsRule = {({meta}) => meta.attributes[0].value === "Bedroom"} 
        sliceStart = {0} 
        loading = {loading} 
        data = {data} 
        error = {error} 
        localData = {localData}
      />
      <Footer/>

    </>
  );
};

export default Bedrooms;